import { render } from "./ClienteModal.vue?vue&type=template&id=701d069a&scoped=true"
import script from "./ClienteModal.vue?vue&type=script&lang=js"
export * from "./ClienteModal.vue?vue&type=script&lang=js"

import "./ClienteModal.vue?vue&type=style&index=0&id=701d069a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701d069a"]])

export default __exports__